<template>
	<span v-if="isEnabledInMeta">
		<a class="btn btn-default" v-if="isDisabledByUser" @click="toggleDisable(false)">
			Вкл. уведомления об изменениях
		</a>

		<!-- Или так: <label class="checkbox"><input type="checkbox" @change="toggleDisable(!isDisabledByUser)" :checked="!isDisabledByUser" /> Уведомлять об изменённых записях </label> button button-outline-light -->

		<notifications :group="notificationGroupId" :speed="0" :width="400">
			<template slot="body">
				<div :class="[`vue-notification-template vue-notification`, notificationType]">
					<div class="notification-content">
						Внимание!
						<div>Со времени последнего обновления данных изменены следующие записи:</div>
						<ul>
							<li v-for="cr in changedRecords" :key="cr.pkey">
								<RouterLink :to="getCardRoute(cr.pkey)" class="chno-link" target="_blank">{{ cr.title }}</RouterLink>
							</li>
						</ul>
						<template v-if="pagingLimitExceededBy"> ...и ещё {{ pagingLimitExceededBy }} шт. </template>
						<div class="text-right">
							<small>
								<a class="chno-link" @click="toggleDisable(true)">Отказаться от получения уведомлений</a>
							</small>
						</div>
					</div>
				</div>
			</template>
		</notifications>
	</span>
</template>

<script>

import dateUtil from '../../util-date.js';
import axios from 'axios';

const checkInterval = 10000;

/**
 * Функционал проверки изменения записей и уведомления пользователя
 * Компонент колокольчика, который рабоатет магическим образом, если проставлен признак isMultipleArm в метаданных
 * Связан с черновиками
 */
export default {
	name: 'ChangeNotice',
	props: {
		getFetchDataUrl: {
			type: Function,
			required: true,
		},
		fetchDataLastDate: {
			type: Date,
			required: true,
		},
		armId: {
			type: Number,
			required: true,
		},
		metaOptions: {
			type: Object,
			// поле из метаданных вида:
			// changeNotice: {
			//	enabled: true,
			//	titleColumn: 'number_ttk',
			//	dateUpdateColumn: 'sys_date_update',
			//	updateLoginColumn: 'login_editor',
			// },
			// может быть undefined у старых АРМ
		},
	},
	data() {
		const disabledStorageKey = `UARM_CHANGE_NOTICE_DISABLED__${this.$props.armId}`;

		return {
			isEnabledInMeta: !!this.$props.metaOptions,
			checkIntervalId: null,
			notificationGroupId: `changeNoticeGroup-${Math.floor(Math.random() * 1e7)}`,
			notificationType: ``, // warn
			disabledStorageKey,
			isDisabledByUser: !!window.localStorage.getItem(disabledStorageKey),
			changedRecords: [],
			doCheckCancelExec: null,
			pagingLimitExceededBy: 0,
		};
	},
	mounted() {
		if (!this.$data.isEnabledInMeta) return;

		this.$data.checkIntervalId = window.setInterval(this.doCheck, checkInterval);
	},
	destroyed() {
		window.clearInterval(this.$data.checkIntervalId);
	},
	methods: {
		doCheck() {
			if (this.$data.isDisabledByUser) return;

			const fetchDataUrl = this.$props.getFetchDataUrl();
			const minDateFilter = dateUtil.dateObjToToHumanFullSec(this.$props.fetchDataLastDate);
			// без таймзоны, тк не удалось сделать в постгресе to_timestamp указывая таймзону
			// здесь некритично, тк дата и на клиенте (fetchDataLastDate) и на сервере московская
			const requestUrl = [`${fetchDataUrl}`, `_changeNoticeSinceDate=${minDateFilter}`].join('&');

			this.doCheckCancelRequest();
			const cancelToken = new axios.CancelToken((c) => (this.$data.doCheckCancelExec = c));

			let linkTitleTemplate = this.$props.metaOptions && this.$props.metaOptions.linkTitleTemplate;
			if (linkTitleTemplate) {
				// удаляем пробелы перед и после фигурных скобок
				linkTitleTemplate = linkTitleTemplate.replace(/{{\s+/, '{{').replace(/\s+}}/, '}}');
			}

			axios.get(requestUrl, { cancelToken }).then(res => {
				if (this.$data.isDisabledByUser) return;

				const recs = res.data.records;
				if (recs && recs.length) {
					this.$data.changedRecords = recs.map(rec => {
						const fieldsMap = Object.assign(
							...rec.fields.map(({ fieldId, value }) => ({ [fieldId.toLowerCase()]: value }))
						);

						const pkey = rec.primaryKeyValue;
						let title;

						if (linkTitleTemplate) {
							title = linkTitleTemplate;
							for (const colName in fieldsMap) {
								// такая вот замена replaceAll, потому что тот ещё толком не поддерживается
								title = title.split(`{{${colName.toLowerCase()}}}`).join(fieldsMap[colName]);
							}
						} else {
							title = fieldsMap.name || `ID=${pkey}`;
						}

						return { pkey, title };
					});
					this.$data.pagingLimitExceededBy = recs ? res.data.count - recs.length : 0;
					this.cleanAllNotifications();
					this.$notify({ group: this.notificationGroupId,	duration: -1 });
				}
			});
		},
		doCheckCancelRequest() {
			if (this.$data.doCheckCancelExec) this.$data.doCheckCancelExec('Отмена предыдущего запроса ChangeNotice');
		},
		cleanAllNotifications() {
			this.$notify({ group: this.notificationGroupId, clean: true }); // очищаем все предыдущие для этой группы
		},
		toggleDisable(bSetDisable) {
			this.$data.isDisabledByUser = bSetDisable;
			if (bSetDisable) {
				window.localStorage.setItem(this.$data.disabledStorageKey, 'YES');
				this.doCheckCancelRequest();
				this.cleanAllNotifications();
			} else {
				window.localStorage.removeItem(this.$data.disabledStorageKey);
			}
		},
		getCardRoute(recordId) {
			return {
				name: 'ArmView_Card',
				params: {
					// Параметры запроса которые попадают в path
					armId: this.$props.armId,
					vpId: this.$route.params.vpId,
					recordId,
				},
			};
		},
	}
}
</script>
